import {Component, OnInit, ViewChild} from '@angular/core';
import {ConfirmationService, SelectItem} from 'primeng/api';
import {ActivatedRoute} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {RoleService} from '../../services/role.service';
import {DocumentService} from '../../services/document.service';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {environment} from '../../../environments/environment';
import {CompanyLabel} from '../../Enum/company-label.enum';
import * as _ from 'lodash';
import {Document} from 'src/app/models/document';
import {firstValueFrom} from 'rxjs';

@Component({
  selector: 'app-document-crud',
  templateUrl: './document-crud.component.html',
  styleUrls: ['./document-crud.component.scss']
})
export class DocumentCrudComponent implements OnInit {

  @ViewChild('fileUpload') fileUpload: any;
  dropAndDropPlaceholder = 'Upload or drop file here';
  modeCreate: boolean;
  modeEdit: boolean;
  modeRead: boolean;
  document: Document;
  labelsItems: SelectItem[] = [
    {label: 'Mckay Brothers', value: 1},
    {label: 'Quincy Data', value: 2},
    {label: 'Vendor', value: 4}
  ];
  selectedLabels: string[] = [];
  companiesItems: SelectItem[];
  selectedCompanies = [];
  selectedCompaniesLabels = [];
  tagsItems: SelectItem[] = [];
  selectedTags: SelectItem[] = [];
  groupsItems: SelectItem[] = [];
  selectedGroups: string[] = [];
  maxSize: number;
  mimeTypes: string[];
  extensions: string[];
  mimeTypesDisplayed: string;
  uploadedNewDocument = false;
  uploadNewPdfDocumentForm: any;
  formData: FormData;
  filename: string;
  loading: boolean;
  error: boolean;
  errorMessage: string;
  success: boolean;
  successMessage: string;
  fileSizeError: boolean;
  mimeTypeError: boolean;
  mimeTypeInvalid: string;
  extensionError: boolean;
  extensionInvalid: string;
  displayNotificationButton: boolean;
  displayNotificationNewButton: boolean;
  successSendNotification: boolean;
  listClients = [];

  constructor(private _route: ActivatedRoute,
              private http: HttpClient,
              private roleService: RoleService,
              private documentService: DocumentService,
              private utilsService: UtilsService,
              private confirmationService: ConfirmationService,
              private authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    this.loading = true;
    this.utilsService.lockUi();
    this.successSendNotification = this.documentService.successSendNotification;
    this.documentService.fileNotFound = false;
    this.fileSizeError = false;
    this.mimeTypeError = false;
    this.extensionError = false;
    this.displayNotificationButton = false;
    this.displayNotificationNewButton = this.documentService.displayNotificationNewButton;
    this.initMessages();
    this.formData = new FormData();
    this.initFields();
    this.initDocumentPage();
  }

  private initDocumentPage() {
    this._route.paramMap.subscribe(params => {
      const documentUniqid = params.get('documentUniqid');
      const action = params.get('actionName');
      if (action === 'new') {
        this.setCreateMode();
        this.getDocumentMaxSizeMimeTypes();
        this.getClients();
        this.selectedGroups.push(this.groupsItems.find(x => x.value === 1).value.toString());
        return;
      }
      if (!documentUniqid) {
        this.redirectionToNotFound();
      }
      if (action === 'edit') {
        this.setEditMode();
        this.getDocumentMaxSizeMimeTypes();
        this.getClients(documentUniqid);
      } else {
        this.setShowMode();
        this.getClients(documentUniqid);
      }
    });
  }

  private setCreateMode() {
    this.modeCreate = true;
    this.modeEdit = false;
    this.modeRead = false;
  }

  private setEditMode() {
    this.modeCreate = false;
    this.modeEdit = true;
    this.modeRead = false;
  }

  private setShowMode() {
    this.modeCreate = false;
    this.modeEdit = false;
    this.modeRead = true;
  }

  private initFields() {
    this.tagsItems = [
      {label: 'Getting Started', value: 'Getting Started'},
      {label: 'Network', value: 'Network'},
      {label: 'Finance or accounting', value: 'Finance or accounting'},
      {label: 'API', value: 'API'},
      {label: 'Quincy Data', value: 'Quincy Data'},
      {label: 'Encrypted', value: 'Encrypted'},
      {label: 'Non Encrypted', value: 'Non Encrypted'},
      {label: 'Tech Specs', value: 'Tech Specs'}
    ];
    this.groupsItems = this.roleService.roles.map(role => {
      if (role.sfGuardGroupId === 1) {
        return {
          label: role.sfGuardGroupDescription,
          value: role.sfGuardGroupId,
          title: role.description,
          disabled: true
        };
      }
      return {label: role.sfGuardGroupDescription, value: role.sfGuardGroupId, title: role.description};
    });
  }

  private getDocumentMaxSizeMimeTypes() {
    this.documentService.getDocumentMaxSizeMimeTypes().subscribe({
        next: (result: any[]) => {
          this.maxSize = result['maxSize'];
          this.mimeTypes = result['mimeTypes'];
          this.extensions = result['extensions'];
          this.mimeTypesDisplayed = '';
          _.forEach(this.mimeTypes, (type: string) => {
            this.mimeTypesDisplayed += type + ', ';
          });
          this.mimeTypesDisplayed = this.mimeTypesDisplayed.slice(0, -1);
        }, error: error => {
          this.error = true;
          this.errorMessage = error.error.message;
        }
      }
    );
  }

  private getClients(documentUniqid = null) {
    const companyUrl = environment.baseUrlWs + '/api/clients-dropdown';
    this.utilsService.cacheablePromise(() => firstValueFrom(this.http.get<any>(companyUrl)),
      'companiesDropDown__' + this.authenticationService.userImpersonatedId,
      true)
      .then(
        response => {
          this.listClients = response['member'].filter(client => client.uniqid !== 'admin' && client.isActive !== false);
          if (this.modeCreate) {
            this.refreshCompaniesItems();
            this.document = new Document();
            this.document.monitor = false;
            this.loading = false;
            this.utilsService.unlockUi();
          } else {
            this.getDocumentByUniqid(documentUniqid);
          }
        }, error => {
          this.error = true;
          this.errorMessage = error.error.message;
        }
      );
  }

  private getDocumentByUniqid(documentUniqid) {
    this.documentService.getDocumentByUniqid(documentUniqid).subscribe({
        next: (document: any) => {
          if (document.length === 0) {
            this.redirectionToNotFound();
          } else {
            this.refreshCompaniesItems();
            this.initializeForms(document[0]);
            this.loading = false;
            this.utilsService.unlockUi();
          }
        },
        error: error => {
          this.error = true;
          this.errorMessage = error.error.message;
        }
      }
    );
  }

  private initializeForms(document: Document) {
    this.document = document;
    const now = new Date().getTime();
    this.displayNotificationButton = ((now - new Date(document.availableSince).getTime()) / 3600000) < 24;
    this.selectedCompanies = [];
    this.selectedLabels = [];
    this.selectedTags = [];
    if (this.availableToMckayBrothers(this.document)) {
      this.selectedLabels.push(this.labelsItems.find(label => label.value === 1).value.toString());
    }
    if (this.availableToQuincyData(this.document)) {
      this.selectedLabels.push(this.labelsItems.find(label => label.value === 2).value.toString());
    }
    if (this.availableToVendor(this.document)) {
      this.selectedLabels.push(this.labelsItems.find(label => label.value === 4).value.toString());
    }
    if (this.document.company.length > 0) {
      this.selectedCompaniesLabels = [];
      this.document.company.map(company => {
        if (!company.isActive) {
          company.name = company.name + ' (Inactive)';
          this.companiesItems.push({
            label: company.name,
            value: company.uniqid
          });
        }
        this.selectedCompanies.push(company.uniqid);
        this.selectedCompaniesLabels.push(company.name);
      });
    }
    this.document.tag = this.document.tag.replace(/,\s/g, ';');
    const tags = this.document.tag.split(';');
    _.forEach(this.tagsItems, (tag: SelectItem) => {
      if (tags.includes(tag.value)) {
        this.selectedTags.push(tag.value);
      }
    });
    for (const groupName of this.document.group) {
      this.selectedGroups.push(this.groupsItems.find(group => group.value === groupName.id).value.toString());
    }
  }

  private availableToMckayBrothers(document: Document) {
    const label = document.label;
    return label === CompanyLabel.LABEL_MCKAY
      || label === CompanyLabel.LABEL_ALL_VENDOR
      || label === CompanyLabel.LABEL_MCKAY_VENDOR
      || label === CompanyLabel.LABEL_ALL;
  }

  private availableToQuincyData(document: Document) {
    const label = document.label;
    return label === CompanyLabel.LABEL_QUINCY || label === CompanyLabel.LABEL_ALL_VENDOR ||
      label === CompanyLabel.LABEL_QUINCY_VENDOR || label === CompanyLabel.LABEL_ALL;
  }

  private availableToVendor(document: Document) {
    const label = document.label;
    return label === CompanyLabel.LABEL_VENDOR || label === CompanyLabel.LABEL_MCKAY_VENDOR ||
      label === CompanyLabel.LABEL_QUINCY_VENDOR || label === CompanyLabel.LABEL_ALL_VENDOR;
  }

  onFileSelected(event) {
    if (event.files.length > 0) {
      if (!this.isValidSize(event.files[0].size)) {
        this.fileSizeError = true;
        return;
      }
      if (event.files[0].type !== null && event.files[0].type !== '') {
        if (!this.checkMimeTypes(event.files[0].type)) {
          this.mimeTypeError = true;
          this.mimeTypeInvalid = event.files[0].type;
          return;
        }
      } else {
        if (!this.checkExtensions(event.files[0].name.substr(event.files[0].name.indexOf('.') + 1))) {
          this.extensionError = true;
          this.extensionInvalid = event.files[0].name.substr(event.files[0].name.indexOf('.') + 1);
          return;
        }
      }
      this.uploadNewPdfDocumentForm = <File>event.files[0];
      this.filename = this.document.filename;
      this.document.filename = event.files[0].name;
      this.dropAndDropPlaceholder = event.files[0].name;
      this.uploadedNewDocument = true;
    }
  }

  private checkMimeTypes(mimeType: string): boolean {
    return this.mimeTypes.includes(mimeType);
  }

  private checkExtensions(extension: string): boolean {
    return this.extensions.includes(extension);
  }

  clearFile() {
    this.fileUpload.clear();
    if (this.filename && this.filename !== '') {
      this.document.filename = this.filename;
    }
    this.fileSizeError = false;
    this.mimeTypeError = false;
    this.mimeTypeInvalid = '';
  }

  private isValidSize(size: number): boolean {
    return size <= this.maxSize * (1024 * 1024);
  }

  onclickEdit() {
    this.initMessages();
    this.loading = true;
    this.utilsService.lockUi();
  }

  onSubmit(documentForm): void {
    this.initMessages();
    try {
      if (!documentForm.valid) {
        return;
      }
      if (this.selectedCompanies.length === 0 && this.selectedLabels.length === 0) {
        return;
      }
      if (this.uploadedNewDocument) {
        this.formData.append('file', new Blob([this.uploadNewPdfDocumentForm],
          {
            type: 'application/json'
          }));
        if (this.modeEdit) {
          this.confirmationService.confirm({
            message: 'Would you like to notify this document watchers of this change?',
            accept: () => {
              this.prepareDocument(true);
            }, reject: () => {
              this.prepareDocument(false);
            },
            key: 'sendNotificationCD'
          });
        } else {
          this.prepareDocument(false);
        }
      } else {
        this.prepareDocument(false);
      }
    } catch (error) {
      this.error = true;
      this.errorMessage = error.error.message;
    }
  }

  private prepareDocument(withNotification) {
    if (this.modeEdit) {
      this.document.company = null;
    }
    this.document.companiesUniqids = [];
    if (this.selectedCompanies.length > 0) {
      this.document.companiesUniqids = this.selectedCompanies;
    }
    this.document.label = 0;
    if (this.selectedLabels.length > 0) {
      this.document.label = this.selectedLabels.map(label => Number(label)).reduce((sum, current) => sum + current);
    }
    this.document.tag = this.selectedTags.join(', ');
    this.document.group = this.selectedGroups.map(group => group);
    this.document.title = this.document.title !== '' ? this.document.title : this.document.filename;
    this.document.notification = withNotification;
    this.sendUploadRequestToApi();
  }

  private sendUploadRequestToApi() {
    this.formData.append('info', JSON.stringify(this.document));
    if (!this.document.uniqid) {
      this.documentService.addDocument(this.formData).subscribe({
          next: (result: any) => {
            this.uploadedNewDocument = false;
            location.assign('/#/document/' + result.documentUniqid + '/show');
            this.success = true;
            this.successMessage = result.message;
            this.documentService.displayNotificationNewButton = true;
            this.successSendNotification = false;
          },
          error: error => {
            this.error = true;
            this.errorMessage = error.error.message;
          }
        }
      );
    } else {
      this.utilsService.lockUi();
      this.documentService.updateDocument(this.document.uniqid, this.formData).subscribe({
          next: (result: any) => {
            this.uploadedNewDocument = false;
            location.assign('/#/document/' + this.document.uniqid + '/show');
            this.success = true;
            this.successMessage = result.message;
            this.displayNotificationButton = true;
            this.successSendNotification = false;
            this.utilsService.unlockUi();
          },
          error: error => {
            this.error = true;
            this.errorMessage = error.error.message;
            this.utilsService.unlockUi();
          }
        }
      );
    }
  }

  redirectionToNotFound() {
    this.utilsService.redirectToNotFound();
  }

  getUserCurrent() {
    return this.authenticationService.getUserCurrent();
  }

  deleteDocument(): void {
    this.initMessages();
    if (!this.document) {
      return;
    }
    if (confirm(`Are you sure you want to delete "${this.document.title}" ?`)) {
      this.documentService.deleteDocument(this.document.uniqid).subscribe({
          next: (res: any) => {
            this.document.deleted = true;
            location.assign('/#/document/' + this.document.uniqid + '/show');
            this.success = true;
            this.successMessage = res.message;
          },
          error: error => {
            this.error = true;
            this.errorMessage = error.error.message;
          }
        }
      );
    }
  }

  dropHandler(event) {
    event.preventDefault();
    this.fileUpload.files = event.dataTransfer.files;
    this.onFileSelected({files: event.dataTransfer.files});
  }

  dragOverHandler(event) {
    event.preventDefault();
  }

  dragLeaveHandler(event) {
    event.preventDefault();
    event.target.style.backgroundColor = 'transparent';
  }

  private initMessages() {
    this.error = false;
    this.errorMessage = '';
    this.success = false;
    this.successMessage = '';
  }

  private refreshCompaniesItems() {
    this.companiesItems = [];
    this.listClients.forEach(client => {
      this.companiesItems.push({
        label: client.name,
        value: client.uniqid
      });
    });
    this.companiesItems = _.sortBy(this.companiesItems, ['label']);
  }
}
